(() => {
  const initializeShowroom = (showroom) => {
    if (showroom.dataset.cwShowroomInitialized === 'true') return;

    const track = showroom.querySelector('[data-cw-showroom-track]');
    const items = Array.from(showroom.querySelectorAll('[data-cw-showroom-item]'));
    const previous = showroom.querySelector('[data-cw-showroom-prev]');
    const next = showroom.querySelector('[data-cw-showroom-next]');
    if (!track || items.length < 2 || !previous || !next) return;

    showroom.dataset.cwShowroomInitialized = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    let frame = 0;

    const setHidden = (button, hidden) => {
      button.classList.toggle('is-hidden', hidden);
      button.disabled = hidden;
      button.setAttribute('aria-hidden', String(hidden));
    };

    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = end > 2;
        setHidden(previous, !hasOverflow || track.scrollLeft <= 2);
        setHidden(next, !hasOverflow || track.scrollLeft >= end - 2);
      });
    };

    const move = (direction) => {
      if (window.matchMedia('(max-width: 640px)').matches) {
        const current = items.reduce((best, item, index) => {
          const distance = Math.abs(item.offsetLeft - track.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
        const target = Math.max(0, Math.min(current + direction, items.length - 1));
        track.scrollTo({ left: items[target].offsetLeft, behavior: 'smooth' });
        return;
      }

      track.scrollBy({
        left: direction * Math.max(track.clientWidth * .85, 240),
        behavior: 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    track.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { passive: true, signal });

    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    resizeObserver?.observe(track);
    update();

    showroom.cwShowroomCleanup = () => {
      cancelAnimationFrame(frame);
      resizeObserver?.disconnect();
      controller.abort();
      delete showroom.dataset.cwShowroomInitialized;
    };
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-cw-showroom]').forEach(initializeShowroom);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cw-showroom]').forEach((showroom) => showroom.cwShowroomCleanup?.());
  });
})();
